export default __webpack_public_path__ + "static/media/Bean Eater-1s-207px.e7a24493.gif";